module.exports = __webpack_public_path__ + "assets/1792649897182/img/page-top.8a116872.png";